import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sdg-dashboard-by-sdg" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-list" }
const _hoisted_4 = { class: "chart" }

import { ref } from "vue";

import ViTable from "@/components/elements/vi-table/vi-table.vue";
import ViSelect from "@/components/elements/vi-select/vi-select.vue";
import ViBarChart from "@/components/elements/vi-charts/bar/vi-bar-chart.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'sdg-impact-by-sdg',
  setup(__props) {

const selectedSDG = ref("a87dfga");
const sdgList = ref([
  {
    uid: "a87dfga",
    value: "a87dfga",
    label: "SDG 1: Poverty",
  },
]);
const data = ref({
  labels: ["Impact Score", "Positive Impact", "Negative Impact"],
  datasets: [
    {
      axis: "y",
      data: [25, 27, -5],
      backgroundColor: ["#4F8FF7", "#2CBFAF", "#E66E79"],
    },
  ],
});
const options = ref({
  indexAxis: "y",
  barThickness: 80,
  scales: {
    x: {
      min: -100,
      max: 100,
    },
  },
  options: {
    plugins: {
      datalabels: {
        align: "end",
        anchor: "end",
        color: "#585868",
        font: {
          size: 13,
          weight: 600,
        },
      },
    },
  },
});

const rows = ref([
  {
    company: "Pixelmatters",
    impactScore: 30,
    positiveImpact: "+35",
    negativeImpact: "-5",
    actions: "",
  },
  {
    company: "Uniplaces",
    impactScore: 30,
    positiveImpact: "+35",
    negativeImpact: "-5",
    actions: "",
  },
  {
    company: "757 Angels",
    impactScore: 30,
    positiveImpact: "+35",
    negativeImpact: "-5",
    actions: "",
  },
]);
const columns = ref([
  {
    label: "Company",
    accessor: "company",
  },
  {
    label: "Impact Score",
    accessor: "impactScore",
  },
  {
    label: "Positive Impact",
    accessor: "positiveImpact",
  },
  {
    label: "Negative Impact",
    accessor: "negativeImpact",
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-title" }, "SDG 1: Poverty", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "SELECT SDG", -1)),
        _createVNode(ViSelect, {
          options: sdgList.value,
          "selected-option": selectedSDG.value
        }, null, 8, ["options", "selected-option"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "chart__header" }, [
        _createElementVNode("span", { class: "chart__title" }, "Impact across all companies"),
        _createElementVNode("span", { class: "chart__link" }, "How impact is measured")
      ], -1)),
      _createVNode(ViBarChart, {
        data: data.value,
        scales: options.value.scales,
        "index-axis": options.value.indexAxis,
        "bar-thickness": options.value.barThickness,
        options: options.value.options
      }, null, 8, ["data", "scales", "index-axis", "bar-thickness", "options"]),
      _createVNode(ViTable, {
        columns: columns.value,
        data: rows.value
      }, null, 8, ["columns", "data"])
    ])
  ]))
}
}

})